import React from 'react';
import Result from './Result';

export default React.createClass({
    propTypes: {
        urls: React.PropTypes.object,
        i18n: React.PropTypes.object,
        profilePhotoPlaceholderUrl: React.PropTypes.string
    },
    getInitialState() {
        return {
            data: [],
            loading: true,
            error: false
        };
    },
    componentWillMount() {
        this.serverRequest = $.get(this.props.urls.get, (result) => {
            if (result.Error) {
                this.setState({
                    loading: false,
                    error: true
                });
            } else {
                this.setState({
                    loading: false,
                    data: result
                });
            }
        }).fail(() => {
            this.setState({
                loading: false,
                error: true
            });
        });
    },
    componentWillUnmount: function() {
        this.serverRequest.abort();
    },
    handleRemoveFriend(id) {
        this.setState({
            data: _.reject(this.state.data, { 'SecureId': id })
        });
    },
    render() {
        return (
            <div className="c-linkBlockGroup">
                <Result
                    loading={this.state.loading}
                    error={this.state.error}
                    data={this.state.data}
                    removeButton={true}
                    onRemove={this.handleRemoveFriend}
                    urls={this.props.urls}
                    i18n={this.props.i18n}
                    profilePhotoPlaceholderUrl={this.props.profilePhotoPlaceholderUrl}
                />
            </div>
        );
    }
});
